import { useRouteMatch } from "react-router";
import {useClassNames} from '../../../hooks/useClassNames';
import { v4 as uuidv4 } from 'uuid';
import React from "react";

/**
 * @param {*} SidebarSelect 
 */
export const SidebarSelect = ({ label, name, value, options, onChange, disabled, error }) => {
  const classNames = useClassNames();
  const id = `sidebarSelect${uuidv4()}`;

  return (
    <>
      <div className="tw-space-y-1 tw-px-4 sm:tw-space-y-0 sm:tw-grid sm:tw-grid-cols-1 sm:tw-gap-1 sm:tw-px-6 sm:tw-py-1">
        <div>
          <label
            htmlFor={id}
            className="tw-block tw-text-sm tw-font-medium tw-text-gray-900 sm:tw-mt-px sm:tw-pt-2"
          >
            {label}
          </label>
        </div>
        <div className="sm:tw-col-span-2">
          <select
            id={id}
            name={name}
            disabled={disabled}
            className={classNames.classNames(
              "tw-block tw-w-full tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-border-0 tw-py-1.5 tw-px-3 tw-text-gray-900 placeholder:tw-text-gray-400 sm:tw-text-sm sm:tw-leading-6 focus:tw-ring-indigo-700 focus:tw-border-indigo-700 focus:tw-ring-2",
              error
                ? "tw-placeholder-red-300 focus:tw-ring-red-500 focus:tw-border-red-500 tw-border-red-300 tw-text-red-900 "
                : ""
            )}
            value={value}
            onChange={onChange}
          >
            {
              options.map((option, index) => {
                return (<option key={`${option.name}${option.value}`} value={option.value}>{option.name}</option>)
              })
            }
          </select>
          {
            error &&
            <p className="tw-mt-2 tw-text-sm tw-text-red-800" id="email-error">
              {error}
            </p>
          }
        </div>
      </div>
    </>
  );
}